import { ReactElement } from 'react';

// Any change to the text, update TermsVersion in terms-config.json to trigger alert for users
const TermsOfUse = (): ReactElement => (
    <>
        <section role='contentinfo' aria-labelledby='general'>
            <h4 id='general'>1. General</h4>
            <p>
                a. This Online Service portal (
                <strong>Portal</strong>
                ) is owned and operated by the
                Commonwealth of Australia as represented by the Department of Industry, Science and Resources (
                <strong>Department, we, us</strong>
                ).
            </p>
            <p>
                b. The Portal is available for you to access NMI services and upload Material, subject to these terms of use (
                <strong>Terms</strong>
                ).
            </p>
            <p>
                c. By accessing or using this Portal, you irrevocably agree to be bound by
                these Terms.
            </p>
            <p>d. In these Terms, the following definitions are used.</p>
            <div className='ms-4'>
                <p>
                    a.
                    <strong>{' Material '}</strong>
                    means materials,
                    information, documents or data or any
                    combination of them
                </p>
                <p>
                    b.
                    <strong>
                        {' Your Material '}
                    </strong>
                    means Material you submit, post, transmit to or otherwise upload
                    or enter onto the Portal;
                </p>
                <p>
                    c.
                    <strong>{' Our Material '}</strong>
                    means Material we present on, that is otherwise contained on or that forms part of, the Portal, other than Your Material;
                </p>
                <p>
                    d.
                    <strong>
                        {' IP Rights '}
                    </strong>
                    means all intellectual property rights, including the following:
                </p>
                <div className='ms-4'>
                    <p>
                        i. Copyright, patents, rights in circuit layouts, trademarks, design, trade
                        secrets, know how, domain names and any right to have confidential information
                        kept confidential;
                    </p>
                    <p>
                        ii. Any application or right to apply for registration of any of the rights
                        referred to in paragraph (i); and
                    </p>
                    <p>
                        iii. All rights of a similar nature to any of the rights in paragraphs (i)
                        and (ii) which may subsist in Australia or elsewhere, whether or not such
                        rights are registered or capable of being registered.
                    </p>
                </div>
            </div>

            <p>e. In these terms:</p>
            <div className='ms-4'>
                <p>
                    i. Words in the singular include the plural and words in the plural include
                    the singular;
                </p>
                <p>
                    ii. A reference to the word &quot;including&quot; in any form is not to be interpreted
                    as a word of limitation; and
                </p>
                <p>
                    iii. Capitalised terms that are defined in these Terms have the same meaning
                    when used elsewhere in these Terms.
                </p>
            </div>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='use-of-portal'>
            <h4 id='use-of-portal'>2. Use of portal</h4>
            <p>
                a. You must only use the Portal, or Our Material, for the limited purposes
                set out in paragraph 2(b). Subject to paragraph 2(b), you are prohibited from:
            </p>
            <div className='ms-4'>
                <p>i. Reproducing Our Material;</p>
                <p>ii. Reselling or distributing Our Material;</p>
                <p>
                    iii. Re-transmitting
                    Our Material to any other site on the internet
                </p>
                <p>
                    iv. Uploading and/or reposting Our Material to any other site on the Internet; and
                </p>
                <p>
                    v. &quot;framing&quot; Our Material with other material
                    on any other site on the
                    Internet.
                </p>
            </div>
            <p>
                b. You may access and download Our Material from the Portal solely for your own use
                provided that you must not:
            </p>
            <div className='ms-4'>
                <p>
                    i. Make Our Material available to third parties on any commercial terms; or
                </p>
                <p>
                    ii. Remove any copyright or trade mark notices
                    contained on Our Material.
                </p>
            </div>
            <p>c. You must not modify or copy:</p>
            <div className='ms-4'>
                <p>i. The layout of the Portal; or </p>
                <p>
                    ii. Any computer software and code contained in
                    or forming part of the Portal.
                </p>
            </div>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='responsible-use'>
            <h4 id='responsible-use'>3. Responsible use of the Portal</h4>
            <p>
                a. You must only use the Portal for lawful and authorised purposes. Your
                storage, transmission or distribution of any Material in violation of laws of
                the Commonwealth of Australia or any State or Territory of Australia in any way
                that relates to your use of the Poral is prohibited. This includes Material
                that is viewed under law as threatening or obscene, or any Material that may be
                viewed by any entity as a protected trade secret.
            </p>
            <p>
                b. You represent and warrant in relation to Your Material that:
            </p>
            <div className='ms-4'>
                <p>i. such Material is current, complete, and accurate;</p>
                <p>
                    ii. you are authorised to provide Your Material
                    and have the necessary rights in Your Material to grant the licences as provided for in these Terms;
                </p>
                <p>
                    iii. you agree, to the extent reasonably practicable, to promptly update such Material
                    to maintain their completeness and accuracy;
                </p>
                <p>
                    iv. Your Material is not defamatory or a malicious falsehood in relation to any product,
                    service, person or corporation or set of facts or circumstances;
                </p>
                <p>
                    v. Your Material is not the &quot;passing
                    off&quot; of any product or service and does not constitute unfair competition or infringe the rights of
                    any person or corporation;
                </p>
                <p>
                    vi. Your Material does not, and the Department&apos;s use of Your Material will not, infringe
                    any IP Rights; and
                </p>
                <p>
                    vii. Your Material does not infringe any laws.
                </p>
            </div>
            <p>
                c. The Department may reasonably request you to provide proof of your
                identity for verification purposes. By agreeing to these Terms you agree to
                promptly comply with any such request that is made.
            </p>
            <p>
                d. You agree to comply with rules, regulations and acceptable usage policies that may
                be in force for each system that you access via the Portal. If you do not, we
                may terminate or suspend your access to the Portal under paragraph 11.
            </p>
            <p>
                e. You will at all times indemnify and keep indemnified the Department and
                our respective officers, employees and agents (Those Indemnified) from and
                against any loss (including legal costs and expenses on a full indemnity basis)
                or liability incurred by any of Those Indemnified arising from any claim, demand,
                suit, action or proceeding by any person against any of Those Indemnified where
                such loss or liability arose out of, in connection with or in respect of:
            </p>
            <div className='ms-4'>
                <p>i. any breach by you of the Terms;</p>
                <p>ii. Your Material; or</p>
                <p>iii. your use of the Portal.</p>
            </div>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='account-info'>
            <h4 id='account-info'>4.  Account information</h4>
            <p>a. By using the Portal you accept responsibility for:</p>
            <div className='ms-4'>
                <p>
                    i. Maintaining the confidentiality of any account information including
                    user names, logins, passwords, and security questions and answers that you use
                    to access any page or feature on this Portal;
                </p>
                <p>
                    ii. Logging off from your account and any protected areas of the Portal;
                </p>
                <p>
                    iii. All activities occurring under your accounts, use names, logins, passwords, and
                    security questions and answers including that which may result from your
                    negligence, carelessness, misconduct, or failure to use or maintain appropriate
                    security measures; and
                </p>
                <p>
                    iv. Promptly reporting any suspicious or unauthorised conduct concerning your accounts, user
                    names, logins, passwords, or security questions and answers to the Department
                    where you become aware of it.
                </p>
            </div>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='license-use-ip'>
            <h4 id='license-use-ip'>5.  Licence to use Intellectual Property</h4>
            <p>
                a. By uploading Your Material to the Portal, you agree to grant (or procure
                for) the Department a perpetual, non-exclusive and payment-free licence
                throughout the world to:
            </p>
            <div className='ms-4'>
                <p>
                    i. reproduce, use and exploit the IP Rights in Your Material to the full
                    extent permitted by law in any jurisdiction in which the Portal is available to
                    users for all purposes described in these Terms and any reasonably related
                    secondary purposes
                </p>
            </div>
            <p>
                b. To the extent that any moral rights subsist in any of the Material you submit via
                the Portal, you represent and warrant that you consent (and have obtained each
                other author&apos;s consent) to the Department doing any act or omission including
                editing, changing or deleting some or all of the materials or information,
                which would, but for this consent, be contrary to the relevant moral rights.
            </p>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='behalf-of-another'>
            <h4 id='behalf-of-another'>6.  User acting on behalf of another person</h4>
            <p>
                a. Where you are using this Portal to access Our Material relating to, or
                to carry out a transaction on behalf of, another person:
            </p>
            <div className='ms-4'>
                <p>
                    i. you must be currently appointed by that other person to access that Material
                    or carry out that transaction on their behalf, and that appointment must not
                    have been revoked;
                </p>
                <p>
                    ii. if that appointment is based on you holding
                    a certain position (for example, as that other person&apos;s employee or agent) - you must currently hold
                    that position;
                </p>
                <p>
                    iii. if that appointment is based on you holding a certain qualification (for example,
                    as a legal practitioner) - you must currently hold that qualification and that
                    qualification must not currently be suspended or cancelled; and
                </p>
                <p>
                    iv. you agree to comply with any request made by the Department for you to verify your
                    appointment to act under paragraph 6(a), (b) or (c) above.
                </p>
            </div>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='links-websites'>
            <h4 id='links-websites'>7. Links to other websites</h4>
            <p>
                a. This Portal may contain links to sites on the Internet owned and
                operated by third parties and which are not under the Department&apos;s control.
            </p>
            <p>
                b. In relation to the other sites on the Internet, which are linked to the Portal,
                the Department:
            </p>
            <div className='ms-4'>
                <p>
                    i. provides the links to other sites as a convenience to you and the
                    existence of a link to other sites does not imply any endorsement by us of the
                    contents of the linked sites;
                </p>
                <p>
                    ii. is not responsible for accuracy or otherwise of the Material contained
                    on those linked sites; and
                </p>
                <p>
                    iii. to the extent permitted by law, accepts no liability (whether in contract, tort
                    (including negligence), statute or otherwise) in respect of those linked sites.
                </p>
            </div>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='ip-rights'>
            <h4 id='ip-rights'>8. IP Rights</h4>
            <p>
                a. All IP Rights comprised in or derived from the Portal, including
                copyright in Our Material or copyright comprised in the Portal itself or
                arising due to the provision of services by us via the Portal are owned by us
                or the relevant third party owners.
            </p>
            <p>
                b. All logos, icons, brand names or service names that identify the Department remain
                the property of the Commonwealth of Australia. All other trade marks or service
                marks on this Portal are the property of their respective owners. Any
                unauthorised use of Material appearing on the Portal may violate IP Rights of
                the Commonwealth or third parties
            </p>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='online-payments'>
            <h4 id='online-payments'>9. Online Payments</h4>
            <p>
                a. Online payments may be made through the eway gateway. The Department
                accepts no responsibility for the delivery of services by any independent third
                party service providers to the extent permitted by law and is not responsible
                for errors made by you when authorising any deduction against your credit or
                debit card.
            </p>
            <p>
                b. Subject to any responsibilities implied by law and which cannot be excluded, the
                Department is not liable to you for any losses, damages, liabilities, claims
                and expenses (including legal costs and defence or settlement costs) whatsoever
                arising out of or referable to the eway gateway or to third party material,
                whether in contract, tort (including negligence), statute or otherwise.
            </p>
            <p>
                c. Any credit or debit card related data (including your credit or debit
                card details) will be stored and maintained in the eway gateway and not within
                this Portal.
            </p>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='termination-access'>
            <h4 id='termination-access'>10. Termination or suspension of access</h4>
            <p>
                a. The Department may terminate or suspend access to the Portal at any time
                without giving any explanation or justification for the termination or
                suspension. The Department will have no liability for any costs, losses or
                damages of any kind arising as a consequence of terminating of suspending
                access to the Portal.
            </p>
            <p>
                b. If the Department terminates your access to the Portal under clause 11(a), the
                Department will provide you with a refund in respect of any payment made by you
                in advance for a service that is connected with this Portal, where that service
                has not been supplied to you. Where part of the service has been provided to
                you, you will be refunded for that portion of the service that has not been
                provided.
            </p>
            <p>
                c. If the Department terminates your access to the Portal due to your
                breach of these Terms, you will not be entitled to a refund in respect of any
                payment made during your use of the Portal.
            </p>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='removal-info'>
            <h4 id='removal-info'>11. Removal of Information</h4>
            <p>
                a. The Department may remove any Materials included on the Portal,
                including links to other sites on the Internet, at any time without giving any
                explanation or justification for removing the Material.
            </p>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='general-terms'>
            <h4 id='general-terms'>12. General</h4>
            <p>
                a. You must not assign, sub-license or otherwise deal in any other way with
                any of your rights under these Terms without the Department&apos;s prior written
                approval.
            </p>
            <p>
                b. Each indemnity given by you under these Terms is a continuing indemnity which shall
                continue upon expiry or termination of your agreement under these Terms.
            </p>
            <p>
                c. If any part of these Terms is found to be void, unlawful, or
                unenforceable then that part will be deemed to be severable from the balance of
                these Terms and the severed part will not affect the validity and
                enforceability of any remaining provisions.
            </p>
            <p>
                d. These Terms will be governed by and interpreted in accordance with the law of the
                Australian Capital Territory.
            </p>

            <p>
                e. You agree to the non-exclusive jurisdiction of the courts of the
                Australian Capital Territory to determine any dispute arising out of these
                Terms.
            </p>
            <hr className='mb-3 border-0' />
        </section>
        <section role='contentinfo' aria-labelledby='terms-updated'>
            <p id='terms-updated'>
                <strong>{'Date last updated: '}</strong>
                9 July, 2024
            </p>
            <hr className='mb-3 border-0' />
        </section>
    </>
);

export default TermsOfUse;
